import React from "react";

const products = [
  {
    title: "Corrugated Boxes",
    image: "/assets/corrugated_boxes.png",
    description: "High-strength boxes for shipping, storage, and industrial packaging with custom dimensions."
  },
  {
    title: "Angle Boards",
    image: "/assets/Angle_boards.png",
    description: "Rigid corner protection that improves load stability and protects edges during transport."
  },
  {
    title: "PET Straps & PP Straps",
    image: "/assets/PET straps.png",
    description: "Reliable strapping materials for bundling, palletizing, and secure product movement."
  },
  {
    title: "BOPP Tapes",
    image: "/assets/bopp_tapes.png",
    description: "Clean, strong sealing tapes suited for carton closure."
  },
  {
    title: "Stretch Film Rolls",
    image: "/assets/Stretch_film_rolls.png",
    description: "Flexible wrapping rolls that provide dust resistance."
  },
  {
    title: "Air Bubble Sheets",
    image: "/assets/Air bubble Sheets.png",
    description: "Shock-absorbing protective material."
  },
  {
    title: "Seals",
    image: "/assets/seals.png",
    description: "Practical sealing accessories."
  }
];

function Products() {
  return (
    <div className="page-shell">
      <section className="page-hero">
        <div className="container">
          <p className="eyebrow">Products</p>
          <h1>Industrial packaging products designed for protection and precision</h1>
          <p>
            Our product range supports warehousing, dispatch, storage, and transit with durable materials and
            application-specific design.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid cards-3">
            {products.map((product, index) => (
              <article className="product-card" key={product.title} style={{ animationDelay: `${index * 0.08}s` }}>
                <div className="product-media">
  <img
    src={product.image}
    alt={product.title}
    className="product-image"
  />
</div>
                <div className="product-body">
                  <h3>{product.title}</h3>
                  <p>{product.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Products;
